import React from "react";
import SupportChat from "../../../components/support/SupportChat";

const SupportTickets = () => <SupportChat />;

export default SupportTickets;
